import React, { PureComponent } from 'react';
import { Button, ButtonToolbar, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import SmartCard from '../../../shared/components/SmartCard';
import validate from './Validate';
import GraphQL from '../../../GraphQL';
import renderField from '../../../shared/components/form/RenderField';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../../redux/actions/loadingActions';
import { educationStageListByFilterQuery } from '../../../shared/queries/EducationStage';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';

class EducationStageForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    backHandler: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    dto: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      active: PropTypes.bool,
    }),
  };

  static defaultProps = {
    dto: null,
  };

  componentDidMount() {
    let { dto } = this.props;
    const { initialize, backHandler, t } = this.props;
    if (dto) {
      if (dto.id) {
        this.showLoading();
        const filter = {
          id: dto.id,
          active: true,
          filterByStatus: false,
          updaterId: 0,
          name: '',
        };
        const getItemByIdQuery = educationStageListByFilterQuery(filter);
        GraphQL(getItemByIdQuery, {})
          .then((res) => {
            this.hideLoading();
            const educationStageList = res.educationStageListByFilter;
            if (educationStageList.length > 0) {
              dto = { ...educationStageList[0] };
              initialize({
                ...dto,
              });
            } else {
              showNotificationAutoDestroy(
                'danger',
                t('notifications.error'),
                t('notifications.record-not-found')
              );
              backHandler();
            }
          })
          .catch(() => {
            this.hideLoading();
          });
      } else {
        initialize({
          ...dto,
        });
      }
    }
  }

  showLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingTrue());
  }

  hideLoading() {
    const { dispatch } = this.props;
    dispatch(changeLoadingFalse());
  }

  render() {
    const { t, backHandler, handleSubmit } = this.props;
    return (
      <SmartCard title={t('panels.ensino')}>
        <form className="form" onSubmit={handleSubmit}>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.name')}</span>
            <div className="form__form-group-field">
              <Field
                name="name"
                type="text"
                component={renderField}
                maxLength="50"
                placeholder={t('placeholder.education-stage.name')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.description')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="description"
                type="text"
                component="textarea"
                maxLength="500"
                placeholder={t('placeholder.education-stage.description')}
              />
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Label className="generic__label">{t('general.active')}</Label>
              <Field
                name="active"
                component={renderCheckBoxField}
                className="colored-click"
              />
            </div>
          </div>
          <ButtonToolbar className="form__button-toolbar">
            <Button color="primary" onClick={backHandler}>
              {t('general.back')}
            </Button>
            <Button color="success" type="submit">
              {t('general.save')}
            </Button>
          </ButtonToolbar>
        </form>
      </SmartCard>
    );
  }
}

export default reduxForm({
  form: 'EducationStageForm',
  validate,
})(withTranslation('common')(EducationStageForm));
